import { useRef } from "react"
import styles from '../../styles/CanvasGrid.module.css';


export default function CanvasGrid(props) {
  const canvasContainer = useRef(null);

  function fullScreen() {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      if (canvasContainer.current.requestFullscreen) {
        canvasContainer.current.requestFullscreen();
      } else if (canvasContainer.current.webkitRequestFullscreen) {
        
        canvasContainer.current.webkitRequestFullscreen();
      } else if (canvasContainer.current.mozRequestFullScreen) {
        canvasContainer.current.mozRequestFullScreen();
      } else if (canvasContainer.current.msRequestFullscreen) {
        canvasContainer.current.msRequestFullscreen();
      }
    }
  }

  function Sandbox(value){
    var sand_value;
    if (value == "cutedressup" || value == "playcutegames"|| value == "Y8"|| value == "VI"|| value == "bestgamespot") {
      // sand_value = "allow-scripts allow-popups allow-same-origin";
    } else {
      // sand_value =
        // "allow-forms allow-pointer-lock allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation";
    }
    return sand_value;
  }

  return (
    <div className={styles.thumb_canvas_Grid}>
      <div className="canvas-containerr">
        <iframe
          ref={canvasContainer}
          // sandbox={Sandbox(props.brand)}
          className="game-canvas"
          height="600px"
          width="100%"
          frameBorder="0"
          scrolling="no"
          src={props.iframe}
          data-hj-allow-iframe="true"
          
        ></iframe>
        <div className={styles.game_info}>
          <p className="game-title">{props.name}</p>
          <a className="game-fullscreen" onClick={fullScreen}>
            <img alt="Full screen" title="Full screen" src={props.src}></img>
          </a>
        </div>
      </div>
    </div>
  );
}
